export default "__VITE_ASSET__koZNKHcH__"